import './i18n/config';
import './Sentry';

import { ThemeProvider } from '@ysura/common';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/App';
import { KeycloakProvider } from '@/auth';
import { NotistackProvider } from '@/components/Notification';
import { NotificationProvider } from '@/hooks';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <KeycloakProvider>
    <StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <NotistackProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </NotistackProvider>
        </BrowserRouter>
      </ThemeProvider>
    </StrictMode>
  </KeycloakProvider>
);
